import { API } from '../config/config';

const EtiquetaService = {
  generate: (data) => generateEtiqueta(data)
}

const generateEtiqueta = async data => {
  try {
    var response = await API.post('/etiquetas', data, {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'arraybuffer'  // Asegúrate de que los datos sean tratados como binarios
    })
    return response;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

export default EtiquetaService